import { useContext } from "react"
import { AuthContext } from "../../contexts/AuthProvider/AuthProvider"
import type { AuthContextValue } from "../../contexts/AuthProvider/AuthProvider.types"

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext)

  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }

  return context
}
